import { render } from "./SldDiy.vue?vue&type=template&id=2a0b3d2a&scoped=true"
import script from "./SldDiy.vue?vue&type=script&lang=js"
export * from "./SldDiy.vue?vue&type=script&lang=js"

import "./SldDiy.vue?vue&type=style&index=0&id=2a0b3d2a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0b3d2a"]])

export default __exports__